import React, { Dispatch, SetStateAction } from "react";
import "./Redirect.css"

interface RedirectProps {
  setRedirectModalVisibility: Dispatch<SetStateAction<boolean>>
}

export default function Redirect({ setRedirectModalVisibility }: RedirectProps) {
  return (
    <div className="dbr-redirect" onClick={() => { setRedirectModalVisibility(false) }}>
      <div className="dbr-modal">
        This demo app decodes barcodes from images on the server side. Want to try barcode reading from video stream on the client side instead?
        <div className="dbr-modal-btns">
          <a href="https://demo.dynamsoft.com/barcode-reader-js/?source=dbrdemo">Yes</a>
          <button onClick={() => { setRedirectModalVisibility(false) }}>No</button>
        </div>
      </div>
    </div>
  )
}